import { useContext } from "react";

import { AppContext } from "@vahak/core/dist/app-context";
import { GenericObject } from "@vahak/core/dist/custom-types/generic-object";

import { LoadMarketCard } from "../../../services/load/useGetLoadMarketV2/type";
import { TrackEventHandler } from "../../../types/events";
import { useCompactLoadBidding } from "../compact-load-bidding/CompactLoadBiddingProvider";

type UseCompactLoadBidActionOptions = {
    trackEvent?: TrackEventHandler;
    eventData?: GenericObject;
    /** Fired before opening the bid modal (e.g. homepage-specific click event). */
    preBidEventName?: string;
};

export function useCompactLoadBidAction({ trackEvent, eventData, preBidEventName }: UseCompactLoadBidActionOptions) {
    const { setShouldPreventLayoutSwitch } = useContext(AppContext);
    const { openCompactBidding } = useCompactLoadBidding();

    const onClickLoadBid = (loadBidData: LoadMarketCard, rank: number) => {
        if (preBidEventName) {
            trackEvent?.(preBidEventName, { ...eventData, rank });
        }

        // Keep marketing/dashboard layout stable while the bid sheet is open.
        // Without this, DefaultLayout swaps SideNav ↔ TopNav when the modal mounts.
        setShouldPreventLayoutSwitch?.(true);

        openCompactBidding({
            loadData: loadBidData,
            trackRank: rank
        });
    };

    return { onClickLoadBid };
}
